import Vue from 'vue'
import VueRouter, { RouterView } from 'vue-router'
import store from "@/store";
import { locationSearchCode, handleLocationSearch } from './tool'
import { getWechatAccessToken } from '@/apis/wx.api';
import { storeSet, storeGet } from '@/utils/localStore';
import { getBindingUserIdApi, getIPAddr } from '@/apis/common.api';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    children: [
      
    ]
  },
  {
    path: '/clockIn',
    name: 'clockIn',
    component: () => import(/* webpackChunkName: "clockIn" */'../views/clockIn'),
    meta: { title: '签到活动' }, 
  },
  {
    path: '/giftCenter',
    name: 'giftCenter',
    component: () => import(/* webpackChunkName: "giftCenter" */'../views/giftCenter'),
    meta: { title: '礼包中心' }, 
  },
  {
    path: '/myGift',
    name: 'myGift',
    component: () => import(/* webpackChunkName: "myGift" */'../views/giftCenter/myGift'),
    meta: { title: '我的礼包' }, 
  },
  {
    path: '/gameCenter',
    name: 'gameCenter',
    component: () => import(/* webpackChunkName: "gameCenter" */'../views/gameCenter'),
    meta: { title: '在线玩' }, 
  },
  {
    path: '/payAmount',
    name: 'payAmount',
    component: () => import(/* webpackChunkName: "payAmount" */'../views/payAmount'),
    meta: { title: '累充活动' }, 
  },
  {
    path: '/accountBind',
    name: 'accountBind',
    component: () => import(/* webpackChunkName: "accountBind" */'../views/account/bind.vue'),
    meta: { title: '角色绑定' }, 
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // },
  {
    path: '/qwWxGameActivity',
    name: 'qwWxGameActivity',
    component: () => import(/* webpackChunkName: "qwWxGameActivity" */'../views/qiweiMiniGame/qiweiMiniGame.vue'),
    meta: { title: '微信小游戏用户企微承接' }, 
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const HANDLE_MOCK_DATA = () => {
  storeSet('WX_APP_ID', 'wx06bcc1bbddea4e75')
  storeSet('wxAuthQuery', {"wx_app_id":"wx06bcc1bbddea4e75","activityId":"7", "gameId": "10017"}, true)
  storeSet('OPEN_ID', 'olEMh57JnUUby3iaBH0oHnJZGhIs')
}

const getBindUser = async (wxappid) => {
// 获取绑定用户id
  const res2 = await getBindingUserIdApi({ wxappid: wxappid, openid: store.getters['user/openid'] })
  store.commit('user/UPDATE_U_ID', res2.data.uid || '')
  store.commit('user/UPDATE_GAME_USER_NAME', res2.data.syUsername || '')
}

router.beforeEach(async (to, from, next) => {
  // HANDLE_MOCK_DATA()
  const open_id = store.getters['user/openid']
  console.log('store.state.user-->', store.getters['user/openid'])
  const { code, wx_app_id } = to.query;
  const { wx_app_id: store_wx_app_id } = storeGet('wxAuthQuery', true) || {}
  const new_wx_app_id = wx_app_id || store_wx_app_id
  const storeWxAppId = storeGet('WX_APP_ID')
  const wxIdChanged = !storeWxAppId || (new_wx_app_id && new_wx_app_id !== storeWxAppId)

  const params_app_id = new_wx_app_id || storeWxAppId
  // debugger
  // 缓存内没值或者值不是最新 --> 更新本地缓存的微信公众号id

  getIPAddr()
    .then(response => {
      return response.text()
    })
    .then(ip => {
      storeSet('IP_ADDR', ip)
    })

  // 1. 先判断 store 中有无userInfo 且 userInfo 是本微信公众号的
  if (open_id && !wxIdChanged) {
    console.log("用户信息存在 -->", open_id);
    // const uid = store.getters['user/uid']
    // if (!uid) {
      getBindUser(params_app_id).finally(() => {
        next()
      })
    // } else {
      // next()
    // }
    return
  }

  // 2. 没有登录信息也没有授权 code
  if (!code) {
    const redirect_uri = encodeURIComponent(`${window.location.protocol}//${window.location.hostname}${window.location.pathname}?wx_app_id=${params_app_id}`);
    localStorage.setItem('wxAuthQuery', JSON.stringify(to.query));
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${params_app_id}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
    return
  } else {
    // 对被微信拼接了code参数的url处理下 处理掉code
    const _url = window.location.origin + window.location.pathname;
    // 获取微信授权信息
    const res = await getWechatAccessToken({
      code,
      wxappid: params_app_id,
    })
    store.commit('user/UPDATE_USER_INFO', res.data)

    // 获取绑定用户id
    getBindUser(params_app_id).finally(() => {
      window.history.replaceState({}, 0, _url)
      next()
    })
  }

  if (wxIdChanged) {
    storeSet('WX_APP_ID', params_app_id || '')
  }
})

router.afterEach((to, from) => {
  document.title = to.meta.title
})

export default router
